module.exports = __webpack_public_path__ + "static/media/07_1440.cb927961.jpeg";